import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
import FormRow from '@/components/Common/FormRow.vue';
import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
import getOperationOffice from '@/types/responses/getOperationOffice';
import i18n from '@/lang/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'OperationOfficeRow',
  props: {
    modelValue: {},
    initialOperationOfficeId: {},
    errorMessages: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const operationOffice = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(FormRow, {
    title: _unref(i18n).global.t('pages.gpsTrackerSetting.operationOffice'),
    required: true
  }, {
    default: _withCtx(() => [
      _createVNode(SingleOperationOfficeAutoComplete, {
        modelValue: operationOffice.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operationOffice).value = $event)),
        "initial-operation-id": props.initialOperationOfficeId,
        "error-messages": __props.errorMessages,
        clearable: false,
        disabled: __props.disabled,
        class: "autocomplete-width"
      }, null, 8, ["modelValue", "initial-operation-id", "error-messages", "disabled"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})